import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";



export interface IICommissionCheckFilesUploadRequest {
  files: File[];
}

async function commissionCheckFilesUpload(formData: FormData): Promise<any> {
  try {
    return (await axiosInstance.post("/PreControlAddFromFile/CheckFile", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddCommissionParameterCheckFiles() {
  return useMutation<any, Error, FormData>(
    (variables) => commissionCheckFilesUpload(variables)
  );
}
